import React, { useEffect, useMemo, useState } from 'react';
import { isEqual } from 'lodash';
import { useHtsQuery, usePrevious } from 'libs/hooks';
import { getHtsValues, HtsValues, htsValuesContext } from '.';

interface HtsValuesContextProviderProps {
  htsNumbers: string[];
  arrivalDate?: string;
  children: React.ReactNode;
}

const Provider = htsValuesContext.Provider;
export const HtsValuesContextProvider: React.FC<
  HtsValuesContextProviderProps
> = ({ arrivalDate, htsNumbers, children }) => {
  const { getEffectiveUsHtssData, queryEffectiveUsHtss, htsDataLoading } =
    useHtsQuery();
  const data = getEffectiveUsHtssData(arrivalDate);
  const [htsValues, setHtsValues] = useState<HtsValues>(() =>
    getHtsValues(htsNumbers, data),
  );
  const previousHtsNumbers = usePrevious(htsNumbers);
  const previousArrivalDate = usePrevious(arrivalDate);
  useEffect(() => {
    const getValues = async () => {
      const data = await queryEffectiveUsHtss(htsNumbers, arrivalDate);
      const newValues = getHtsValues(htsNumbers, data);
      if (!isEqual(newValues, htsValues)) {
        setHtsValues(newValues);
      }
    };
    if (
      !isEqual(htsNumbers, previousHtsNumbers) ||
      arrivalDate !== previousArrivalDate
    ) {
      void getValues();
    }
  }, [
    htsNumbers,
    arrivalDate,
    previousArrivalDate,
    previousHtsNumbers,
    htsValues,
    getEffectiveUsHtssData,
    queryEffectiveUsHtss,
  ]);

  const value = useMemo(
    () => ({
      htsValues,
      queryLoading: htsDataLoading,
    }),
    [htsValues, htsDataLoading],
  );

  return <Provider value={value}>{children}</Provider>;
};
